import { Component, Inject, input, OnDestroy, OnInit } from '@angular/core';
import { CloudFileModel } from '../../api/models';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatDialogTitle,
  MatDialogClose,
  MatDialogContent,
  MatDialogActions,
} from '@angular/material/dialog';
import { NotificationService } from '../../notification/notification.service';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { FlexModule } from '@angular/flex-layout';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatLabel } from '@angular/material/form-field';
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import * as _ from 'lodash';
import { TextToSpeechDialogComponent } from '../text-to-speech-dialog/text-to-speech-dialog.component';
import { UploadCustomAudioFileComponent } from './upload-custom-audio-file/upload-custom-audio-file.component';

export interface SelectAudioFileDialogData {
  recId: string;
  availableFiles: CloudFileModel[];
  title?: string;
}

@Component({
  selector: 'app-select-audio-file-dialog',
  standalone: true,
  templateUrl: './select-audio-file-dialog.component.html',
  imports: [
    FlexModule,
    MatDialogTitle,
    MatIconButton,
    MatDialogClose,
    MatIcon,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatLabel,
    MatAccordion,
    MatRadioGroup,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatRadioButton,
    UploadCustomAudioFileComponent,
    MatButton,
    MatDialogActions,
  ],
  styles: ['.stretched-container {overflow: auto;}'],
})
export class SelectAudioFileDialogComponent implements OnInit, OnDestroy {
  form: UntypedFormGroup;
  file1: File;
  fileOptionControl = new UntypedFormControl('0', []);

  groupKeys: string[] = [];

  public readonly availableFilesGrouped = _.groupBy(this.data.availableFiles, 'fileGroup');

  constructor(
    public dialogRef: MatDialogRef<SelectAudioFileDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SelectAudioFileDialogData,
    public dialog: MatDialog,
    private notificationService: NotificationService,
    private fb: UntypedFormBuilder,
  ) {}

  public ngOnInit(): void {
    this.groupKeys = Object.keys(this.availableFilesGrouped);

    this.fileOptionControl = new UntypedFormControl(this.data.recId, [Validators.required]);
    this.form = this.fb.group({
      fileOption: this.fileOptionControl,
    });
  }

  public ngOnDestroy(): void {}

  public async onSubmit(): Promise<void> {
    if (this.form.valid) {
      const reqData = this.prepareFormModel();
      if (reqData.recId === '-1' && !this.file1) {
        this.notificationService.notifyDanger('Custom audio file is not selected');
        return;
      }
      this.dialogRef.close(reqData);
    } else if (!this.form.valid) {
      console.error('form not valid', this.form.errors);
    }
  }

  public onFileValidationError($event: string): void {
    this.notificationService.notifyDanger($event);
  }

  public onFileChanged($event: File): void {
    console.log('On file 1 changed', $event);
    this.file1 = $event;
    this.form.patchValue({
      fileOption: '-1',
    });
  }

  public onTextToSpeech(): void {
    this.form.patchValue({
      fileOption: '-2',
    });

    const dialogRef = this.dialog.open(TextToSpeechDialogComponent, {
      id: 'holiday-greetings-text-to-speech-dialog',
      width: '600px',
      height: '70%',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      if (result) {
        console.log(result);

        const audioBlob = this.convertBase64ToBlob(result.base64, result.mimeType);
        this.file1 = new File([audioBlob], 'text-to-speech.wav', { type: result.mimeType });

        this.form.patchValue({
          fileOption: '-2',
        });

        this.onSubmit().then();
      }
    });
  }

  private prepareFormModel(): any {
    const formModel = this.form.getRawValue();

    const fileData = this.data.availableFiles.find(x => x.id === formModel.fileOption);

    console.log(fileData);

    return {
      file: formModel.fileOption == '-1' || formModel.fileOption == '-2' ? this.file1 : null,
      recId: formModel.fileOption,
      filename: this.file1 ? this.file1.name : fileData ? fileData.name : '',
    };
  }

  private convertBase64ToBlob(base64: string, mimeType: string): Blob {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: mimeType });
  }
}
